import { getScopedMatrixStorageKey } from "./matrixStorage";

export const BACKUP_STORAGE_KEYS = {
    BACKUP_MODAL_ACTIONED: "createBackupPasswordRefused",
    USER_KEY_RESTORED: "userKeyRestored"
};

export const getBackupStorageKey = (key, matrixClient) => {
    return getScopedMatrixStorageKey(key, matrixClient);
};

export const getBackupStorageValue = (key, matrixClient) => {
    const storageKey = getBackupStorageKey(key, matrixClient);
    return storageKey ? localStorage.getItem(storageKey) : null;
};

export const setBackupStorageValue = (key, matrixClient) => {
    const storageKey = getBackupStorageKey(key, matrixClient);
    if (storageKey) {
        localStorage.setItem(storageKey, "1");
    }
};

export const removeBackupStorageValue = (key, matrixClient) => {
    const storageKey = getBackupStorageKey(key, matrixClient);
    if (storageKey) {
        localStorage.removeItem(storageKey);
    }
};
